<div class="panel bg-red pt40 pb40">
    <div class="plMd prMd max-auto">
        <h2 class="h3 text-light mb20">People we've worked with...</h2>
        <div class="client-list__logos" *ngFor="let row of logoRows">
            <img *ngFor="let logoSrc of row" class="client-list-logos__img" [src]="logoSrc" alt="">
        </div>
    </div>
</div>
